var map = {
	"./audi.svg": 3647,
	"./bmw.svg": 3648,
	"./chrysler.svg": 3649,
	"./ford.svg": 3650,
	"./heavy.svg": 3651,
	"./hino.svg": 3652,
	"./holden.svg": 3653,
	"./honda.svg": 3654,
	"./hyundai.svg": 3655,
	"./isuzu.svg": 3656,
	"./jeep.svg": 3657,
	"./kia.svg": 3658,
	"./lexus.svg": 3659,
	"./light.svg": 3660,
	"./mazda.svg": 3661,
	"./medium.svg": 3662,
	"./mercedes.svg": 3663,
	"./mitsubishi.svg": 3664,
	"./nissan.svg": 3665,
	"./notdefined.svg": 3666,
	"./passenger.svg": 3667,
	"./plantequip.svg": 3668,
	"./renault.svg": 3669,
	"./service.svg": 3670,
	"./skoda.svg": 3671,
	"./subaru.svg": 3672,
	"./suzuki.svg": 3673,
	"./telematics.svg": 3674,
	"./tow.svg": 3675,
	"./toyota.svg": 3676,
	"./volkswagen.svg": 3677
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3823;


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/fleetComposition ^\.\/.*\.svg$
// module id = 3823
// module chunks = 4